import { Injectable } from "@angular/core";
import { Constants } from "@constants";
import { Tabs } from "@enums/tab.enum";
import { AgreementResponseModel } from "@fs/models/agreement/response.model";
import { CommonMethods } from "@services/common.method";

@Injectable({
    providedIn: 'root'
})
export class TabParams {
    constructor() {};

    static WorkOrderReviewView(wtObj) {
        return {
            tabId: Tabs.FsLiteWorkOrderReviewView,
            params: {
              ID: wtObj.ID,
              jobsiteId: wtObj.JobSite.ID,
              customerId: wtObj.Customer.ID
            },
            tabTitle: wtObj.WorkTicketNo == null ? " " : wtObj.WorkTicketNo
        }
    }

    static AgreementItemView(itemId, itemNo) {
        return {
            tabId: Tabs.FsLiteServiceAgreementItemDetail,
            params: { ID:  itemId},
            tabTitle: 'Agreement - ' + itemNo,
        }
    }
    
    static NewServiceAgreement(wtObj, pbObj) {   
        let model = new AgreementResponseModel();
        CommonMethods.ObjectMapper(wtObj, model.OriginatingWorkticket);
        model.OriginWorkTicketPriceBookItemID = pbObj.ID;
        model.ServiceAgreementEquipments = pbObj.WorkTicketPriceBookItemEquipments.map(x => x.JobSiteEquipment);
        model.ServiceAgreementItem.ID = pbObj.PriceBookItem.EntityID;
        model.ServiceAgreementItem.Prices = pbObj.Price;
        model.ServiceAgreementItem.Note = pbObj.Note;
        return {
            tabId: Tabs.NewServiceAgreement,
            params:  model,
            tabTitle: "New Service Agreement"
        }
    }
    
    static ViewServiceAgreement(saObj, refresh = false) {
        return {
            tabId: Tabs.ServiceAgreementDetail,
            params: { 
                ID: saObj.ID, 
                JobSiteID: saObj.JobSite.ID,
                Data: saObj,
                Load: refresh
            },
            tabTitle: saObj.ServiceAgreementNumber 
        }
    };
    
    static EditServiceAgreement(saObj) {  
        let model = new AgreementResponseModel();
        CommonMethods.ObjectMapper(saObj, model);

        return {
            tabId: Tabs.ServiceAgreementEdit,
            params: model,
            tabTitle: saObj.ServiceAgreementNumber
        }
    }
    
    static ViewWorkOrder(wtObj) {
        return {
            tabId: Tabs.FsLiteWorkOrderView,
            params: {
              ID: wtObj.ID,
              jobsiteId: wtObj.JobSite.ID,
              customerId: wtObj.Customer.ID
            },
            tabTitle: wtObj.WorkTicketNo == null? " " : wtObj.WorkTicketNo
        }
    }

    static NewWorkOrder(obj) {
        return {
            tabId: Tabs.FsLiteWorkOrderCreate,
            params: { 
                data: obj.Customer,
                VisitId: (obj.Visit)? obj.Visit.ID : null,
                PromisedDate: obj.PromisedDate,
                ServiceTypeId: (obj.ServiceType)? obj.ServiceType.ID: null,
                DispatchComment: obj.DispatchComment
            },
            tabTitle: 'New Work Order'
        }
    }

    static NewEstimate(obj) {
        return {
            tabId: Tabs.NewEstimate,
            params: Object.assign(obj),
            tabTitle: 'New Estimate'
        }
    }

    static ViewEstimate(obj, refresh = false) {
        return {
            tabId: Tabs.EstimateDetail,
            params: { 
                ID: obj.ID, 
                CustomerID: obj.Customer.ID,
                JobSiteID: obj.JobSite.ID,
                Data: obj,
                Load: refresh
            },
            tabTitle: obj.EstimateNo 
        }
    };

    static EditEstimate(obj) {
        return {
            tabId: Tabs.EstimateEdit,
            params: Object.assign(obj),
            tabTitle: obj.EstimateNo
        }
    }
}